import axios from "axios";
import LocationRecord from "./types/LocationRecord";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getLatestLocations = async (): Promise<LocationRecord[]> => {
  return axios.get("/locations/latest").then((response) => response.data);
};
